var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaintPalette(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Others"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Design"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paint"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 256,
    cy: 258,
    r: 256,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04BE9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A185"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    cx: 256,
    cy: 256,
    r: 256
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94A5A6"
    },
    d: "M337.543,228.916c-48.986-4.83-51.055-14.489-45.535-46.226s-28.979-60.715-91.762-42.086 c-62.785,18.628-115.91,72.443-95.213,175.935c0,0,28.287,101.421,125.57,116.6c97.281,15.179,157.994-19.318,180.072-89.002 C432.754,274.452,386.529,233.745,337.543,228.916z M204.039,214.427c-11.621,0-21.043-9.421-21.043-21.043 c0-5.381,2.023-10.289,5.346-14.01c-0.992,1.566-1.797,3.263-2.352,5.073c3.783-3.648,8.928-5.896,14.6-5.896 c11.623,0,21.043,9.421,21.043,21.043c0,2.15-0.324,4.224-0.922,6.177c0.406-0.393,0.793-0.805,1.168-1.229 C218.158,210.478,211.562,214.427,204.039,214.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M332.713,232.365c-48.984-4.83-51.055-14.489-45.535-46.226s-28.979-60.715-91.762-42.086 c-62.785,18.628-115.91,72.443-95.211,175.935c0,0,28.287,101.421,125.568,116.6s157.996-19.318,180.074-89.002 C427.926,277.901,381.699,237.195,332.713,232.365z M204.039,214.427c-11.621,0-21.043-9.421-21.043-21.043 s9.422-21.043,21.043-21.043c11.623,0,21.045,9.421,21.045,21.043S215.662,214.427,204.039,214.427z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C6362B"
    },
    cx: 365.141,
    cy: 300.669,
    r: 31.047
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EE483C"
    },
    cx: 359.621,
    cy: 297.22,
    r: 15.869
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32495D"
    },
    d: "M406.529,67.561l-87.41,155.065l-9.014-5.083C310.105,217.543,373.734,49.867,406.529,67.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3E4F"
    },
    d: "M406.529,67.561l-87.41,155.065l9.246,5.211C328.365,227.837,438.646,86.457,406.529,67.561z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.336,
    y: 220.914,
    transform: "matrix(-0.8711 -0.491 0.491 -0.8711 470.1683 591.4255)",
    style: {
      fill: "#F4C342"
    },
    width: 20.698,
    height: 26.217
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.018,
    y: 223.455,
    transform: "matrix(-0.8711 -0.491 0.491 -0.8711 477.3548 598.3921)",
    style: {
      fill: "#F89B36"
    },
    width: 10.348,
    height: 26.216
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94A5A6"
    },
    d: "M297.23,240.382c0,0-39.801-1.051-40.25,39.087c-0.449,40.139-26.186,29.592-26.186,29.592 s36.223,35.181,76.146-3.013c34.381-32.892,8.32-55.503,8.32-55.503L297.23,240.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E8C8D"
    },
    d: "M315.262,250.546l-18.031-10.164c0,0-2.523-0.066-6.305,0.475 c2.32,2.169,24.102,24.118-8.518,55.323c-16.793,16.067-32.934,19.147-45.996,17.327c11.672,8.066,40.02,21.731,70.529-7.458 C341.322,273.157,315.262,250.546,315.262,250.546z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F89B36"
    },
    cx: 323.055,
    cy: 369.663,
    r: 31.047
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4C342"
    },
    cx: 317.535,
    cy: 366.213,
    r: 15.869
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1380B6"
    },
    cx: 251.99,
    cy: 394.501,
    r: 31.047
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1C99D8"
    },
    cx: 246.472,
    cy: 391.051,
    r: 15.868
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00AF67"
    },
    cx: 177.478,
    cy: 363.454,
    r: 31.048
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00CA77"
    },
    cx: 171.958,
    cy: 360.004,
    r: 15.868
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SEO_x2F__Web"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Finance__x2F__Money"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "E-Commerce__x2F__Shopping"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Strategy"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintPalette);
export default __webpack_public_path__ + "static/media/paint-palette.7a5f584a5d1d6cb688118a9a24d52ab1.svg";
export { ForwardRef as ReactComponent };